import { render, staticRenderFns } from "./TipForm.vue?vue&type=template&id=c4d4aa70"
import script from "./TipForm.vue?vue&type=script&lang=ts"
export * from "./TipForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports